import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'

import { sessionReducer } from '../../features/identity'
import { baseApi } from '../../platform/api/base-api'

export function createAppStore() {
  return configureStore({
    reducer: {
      session: sessionReducer,
      [baseApi.reducerPath]: baseApi.reducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(baseApi.middleware),
    enhancers: (getDefaultEnhancers) =>
      getDefaultEnhancers(
        import.meta.env.MODE === 'test'
          ? {
              autoBatch: {
                queueNotification: (notify) => setTimeout(notify, 0),
                type: 'callback',
              },
            }
          : {},
      ),
  })
}

export const appStore = createAppStore()
setupListeners(appStore.dispatch)

export type AppStore = ReturnType<typeof createAppStore>
export type RootState = ReturnType<AppStore['getState']>
export type AppDispatch = AppStore['dispatch']
